import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { members } from '../../../Redux/Slice/AuthSlice';

const RenewSubscription = () => {
    const [activePlan, setActivePlan] = useState(null);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    const plans = [
        { name: 'Starter', price: '$0', features: ['Basic Access', 'Community Forum'] },
        { name: 'Pro', price: '$29', features: ['All Access', 'Priority Support', 'Custom Tools'], popular: true },
        { name: 'Enterprise', price: '$99', features: ['Unlimited Everything', 'Dedicated Manager'] }
    ];
    const handleSub = ({name,price,id,e})=>{
        e.preventDefault()
        dispatch(members(JSON.stringify({name,price,id})))
        navigate('/portal/booking/classes/renew/subscription/checkout')
    }
  return (
 <div className='portal-kiga-question-1-main'>
      <Navbar/>
      <section className='portal-kiga-question-1-section'>
       <div className='portal-kiga-question-1-section-header'>
        <p>Renew Your subscription ?</p>
      </div>
    <div className="container">
      {plans?.map((plan, index) => (
        <div 
          key={index}
          className={`card ${plan.popular ? 'popular' : ''} ${activePlan === index ? 'selected' : ''}`}
          onMouseEnter={() => setActivePlan(index)}
          onMouseLeave={() => setActivePlan(null)}
        >
          {plan?.popular && <span className="badge">Most Popular</span>}
          <h3>{plan?.name}</h3>
          <div className="price">{plan?.price}<span>/mo</span></div>
          <ul>
            {plan?.features?.map((f, i) => <li key={i}>{f}</li>)}
          </ul>
          <button className="btn" onClick={(e)=>handleSub({name:plan?.name,price:plan?.price,id:index,e})}>Get Started</button>
        </div>
      ))}
    </div>
    </section>
    </div>
  )
}

export default RenewSubscription